// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"toggle_wrapper__2-rug","toggle":"toggle_toggle__2xLHd","ball":"toggle_ball__3WrIp","active":"toggle_active__28IfK"};